import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux";
import Type from "../../Redux/Type";
import '../../Styles/tabmap.css'

const MapTypes = () => {

    const { typeMapId } = useSelector(state => state.mapView);
    const { polygons, opacityLevel, showQuyHoach } = useSelector(state => state.quyHoach);
    const dispatch = useDispatch();
    const onChangeSatellite = () => {

        dispatch({ type: Type.SET_TYPE_MAP, value: typeMapId === 'hybrid' ? 'roadmap' : 'hybrid' })
    };
    // 

    const onChangeTransparent = (value) => {

        dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'opacityLevel', value: value / 100 });
    }
    const heightScreenScroll = window.screen.width;
    return (
        <Fragment>

            {
                heightScreenScroll < 450 ? null :
                    <div id="custom-button-layer" style={{ left: '10px', top: 100 }}>
                        <div className={`button-map ${typeMapId === 'hybrid' ? 'button-map-active' : null}`}
                            onClick={() => { onChangeSatellite() }} title={`${typeMapId === 'hybrid' ? "Xem vệ tinh" : "Xem bản đồ"}`} style={typeMapId === 'hybrid' ? styles.vetinhType : styles.defaultType}>
                        </div>
                        {/* <div className={`button-map ${typeMapId === 'roadmap' ? 'button-map-active' : null} `}
                    onClick={()=>{onChangeSatellite('roadmap')}} title="Xem bản đồ" style={styles.defaultType}></div> */}
                        {
                            // showQuyHoach && polygons.length >0 ? 
                            // <input className="range-button-transparent" 
                            // onInput={(e)=>{
                            //     onChangeTransparent(e.target.value)
                            // }}
                            // type="range" id="volume" value={opacityLevel*100} name="volume" min={0} max={100} /> : null
                        }


                    </div>
            }


        </Fragment>
    )
}
export default MapTypes;
const styles = {
    vetinhType: {
        backgroundImage: `url("${process.env.PUBLIC_URL}/images/vetinhmap.png")`
    },
    defaultType: {
        backgroundImage: `url("${process.env.PUBLIC_URL}/images/defaultmap.png")`,
    }

}
